<template>
  <div class="list-page">
    <div class="toolbar">
      <div class="search-box">
        <select v-model="filterCategoryId" class="filter-select" @change="handleSearch">
          <option value="0">全部分类</option>
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
        </select>
        <input v-model="keyword" type="text" placeholder="搜索免费资源..." @keyup.enter="handleSearch" />
        <button class="btn-search" @click="handleSearch">搜索</button>
      </div>
      <button class="btn-primary" @click="$router.push('/free/create')">+ 新建资源</button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="list.length === 0" class="empty"><p>暂无免费资源</p></div>

    <div v-else class="card-list">
      <div v-for="item in list" :key="item.id" class="list-item">
        <div class="item-cover" @click="$router.push('/free/edit/' + item.id)">
          <img v-if="item.image" :src="item.image" alt="cover" />
          <span v-else class="no-cover">暂无封面</span>
        </div>
        <div class="item-body" @click="$router.push('/free/edit/' + item.id)">
          <h4 class="item-title">{{ item.title }}</h4>
          <p class="item-category" v-if="item.category_name">分类：{{ item.category_name }}</p>
          <p class="item-date">{{ item.date }}</p>
        </div>
        <div class="item-actions">
          <button class="btn-edit" @click="$router.push('/free/edit/' + item.id)">编辑</button>
          <button class="btn-del" @click="handleDelete(item)">删除</button>
        </div>
      </div>
    </div>

    <div v-if="total > pageSize" class="pagination">
      <button :disabled="page <= 1" @click="changePage(page - 1)">上一页</button>
      <span class="page-info">{{ page }} / {{ totalPages }}</span>
      <button :disabled="page >= totalPages" @click="changePage(page + 1)">下一页</button>
    </div>

    <div v-if="showDeleteConfirm" class="modal-overlay" @click.self="showDeleteConfirm = false">
      <div class="modal-box">
        <h3>确认删除</h3>
        <p>确定要删除「{{ deleteTarget ? deleteTarget.title : '' }}」吗？</p>
        <div class="modal-actions">
          <button class="btn-cancel" @click="showDeleteConfirm = false">取消</button>
          <button class="btn-primary" @click="confirmDelete">确认删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../api/index';

export default {
  name: 'FreeList',
  data() {
    return {
      list: [], total: 0, page: 1, pageSize: 1000,
      keyword: '', filterCategoryId: 0, categories: [],
      loading: false, showDeleteConfirm: false, deleteTarget: null,
    };
  },
  computed: {
    totalPages() { return Math.ceil(this.total / this.pageSize) || 1; },
  },
  created() { this.fetchCategories(); this.fetchList(); },
  methods: {
    async fetchCategories() {
      try { const res = await request('/categories.php'); this.categories = res.data || []; } catch (e) {}
    },
    async fetchList() {
      this.loading = true;
      try {
        var url = '/free_resources.php?page=' + this.page + '&pageSize=' + this.pageSize;
        if (this.keyword) url += '&keyword=' + encodeURIComponent(this.keyword);
        if (this.filterCategoryId > 0) url += '&category_id=' + this.filterCategoryId;
        const res = await request(url);
        this.list = res.data.list; this.total = res.data.total;
      } catch (e) { alert('加载失败: ' + e.message); }
      finally { this.loading = false; }
    },
    handleSearch() { this.page = 1; this.fetchList(); },
    changePage(p) { this.page = p; this.fetchList(); },
    handleDelete(item) { this.deleteTarget = item; this.showDeleteConfirm = true; },
    async confirmDelete() {
      if (!this.deleteTarget) return;
      try {
        await request('/free_resources.php?id=' + this.deleteTarget.id, { method: 'DELETE' });
        this.showDeleteConfirm = false; this.deleteTarget = null; this.fetchList();
      } catch (e) { alert('删除失败: ' + e.message); }
    },
  },
};
</script>

<style scoped>
.list-page { background: #fff; border-radius: 8px; padding: 24px; box-shadow: 0 1px 4px rgba(0,0,0,0.05); }
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.search-box { display: flex; gap: 8px; align-items: center; }
.filter-select { height: 36px; padding: 0 8px; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 13px; outline: none; background: #fff; min-width: 110px; }
.filter-select:focus { border-color: #1677FF; }
.search-box input { width: 220px; height: 36px; padding: 0 12px; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px; outline: none; }
.search-box input:focus { border-color: #1677FF; }
.btn-search { height: 36px; padding: 0 16px; background: #1677FF; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; }
.btn-primary { height: 36px; padding: 0 20px; background: #1677FF; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; }
.btn-primary:hover { background: #4096ff; }
.loading, .empty { text-align: center; padding: 60px 0; color: #999; }
.card-list { display: flex; flex-direction: column; gap: 8px; }
.list-item { display: flex; align-items: center; padding: 10px 16px; border: 1px solid #f0f0f0; border-radius: 8px; transition: box-shadow 0.2s; }
.list-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.item-cover { width: 70px; height: 70px; border-radius: 6px; overflow: hidden; flex-shrink: 0; cursor: pointer; background: #f5f5f5; display: flex; align-items: center; justify-content: center; }
.item-cover img { width: 100%; height: 100%; object-fit: cover; }
.no-cover { color: #ccc; font-size: 12px; }
.item-body { flex: 1; margin-left: 12px; cursor: pointer; min-width: 0; }
.item-date { font-size: 12px; color: #bbb; margin: 0; }
.item-category { font-size: 13px; color: #1677FF; font-weight: 600; margin: 0; }
.item-title { font-size: 15px; font-weight: 600; color: #222; margin-bottom: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.item-actions { display: flex; flex-direction: column; gap: 8px; margin-left: 16px; flex-shrink: 0; }
.btn-edit { padding: 5px 16px; border: 1px solid #d9d9d9; border-radius: 4px; background: #fff; color: #555; cursor: pointer; font-size: 13px; }
.btn-edit:hover { border-color: #1677FF; color: #1677FF; }
.btn-del { padding: 5px 16px; border: 1px solid #ffccc7; border-radius: 4px; background: #fff; color: #ff4d4f; cursor: pointer; font-size: 13px; }
.btn-del:hover { background: #ff4d4f; color: #fff; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 16px; margin-top: 24px; padding-top: 16px; border-top: 1px solid #f0f0f0; }
.pagination button { padding: 6px 16px; border: 1px solid #d9d9d9; border-radius: 4px; background: #fff; cursor: pointer; font-size: 13px; }
.pagination button:hover:not(:disabled) { border-color: #1677FF; color: #1677FF; }
.pagination button:disabled { color: #ccc; cursor: not-allowed; }
.page-info { color: #666; font-size: 13px; }
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-box { width: 420px; background: #fff; border-radius: 8px; padding: 32px; box-shadow: 0 8px 32px rgba(0,0,0,0.15); }
.modal-box h3 { font-size: 18px; margin-bottom: 12px; }
.modal-box p { color: #666; margin-bottom: 24px; line-height: 1.6; }
.modal-actions { display: flex; justify-content: flex-end; gap: 12px; }
.btn-cancel { height: 36px; padding: 0 20px; border: 1px solid #d9d9d9; border-radius: 4px; background: #fff; cursor: pointer; font-size: 14px; }
</style>
